import Error from '../../../model/Error';
import Helper from '../../../accounting/Helper';
import Offering from '../../../dto/offering/Offering';
import QueryParamEncoder from '../../../service/QueryParamEncoder';
import axios from 'axios';

export default class OfferingRepository {
    static findAll(clubId, preFilters, perpage, page) {
        return new Promise((resolve) => {
            axios
                .get(`/club/clubs/${clubId}/offerings?${QueryParamEncoder.encodeObjectToArray(preFilters, 'filters')}&page=${page}&per_page=${perpage.id}`)
                .then((response) => resolve(response.data.data.map((data) => Offering.fromData(data))));
        });
    }

    static findAllAndGetMeta(clubId, preFilters, perpage, page) {
        return new Promise((resolve) => {
            axios
                .get(`/club/clubs/${clubId}/offerings?${QueryParamEncoder.encodeObjectToArray(preFilters, 'filters')}&page=${page}&per_page=${perpage.id}`)
                .then((response) => resolve(response.data));
        });
    }

    static cancelAllOfferingAppointments(offering, notifyParticipants, notifyClubEmployees) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/offerings/offering/${offering.id}/cancel`, {
                    notifyParticipants,
                    notifyClubEmployees,
                })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadExcel(clubId, preFilters) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings?${QueryParamEncoder.encodeObjectToArray(preFilters, 'filters')}&format=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, {
                    responseType: 'blob',
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', new Helper().getFilenameFromHeaders(response.headers));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(async (error) => {
                    try {
                        reject(await Error.fromBlob(error.response));
                    } catch {
                        reject(error);
                    }
                });
        });
    }

    static delete(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/offerings/${offeringId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/offerings/${offeringId}/archived`, { archived: true })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static restore(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/offerings/${offeringId}/archived`, { archived: false })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static isArchivable(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/offerings/${offeringId}/archivable`)
                .then((response) => resolve(response.data.data.isArchivable))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(offeringId, image) {
        const config = {
            headers: { 'Content-Type': 'application/octet-stream' },
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/offerings/${offeringId}/image`, image, config)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getImageUrl(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/offerings/${offeringId}/image-url`)
                .then((response) => resolve(response.data.data.imageUrl))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/offerings/${offeringId}/image`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
